import styled from 'styled-components';
import { Button } from '~/components';
import { SignatureCanvas, getTheme } from '~/modules';

const xlSpacing = getTheme('spacing.xl');
const backgroundZ3 = getTheme('background.z3');

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  flex: 1;
  position: relative;
  align-items: center;
  padding: ${xlSpacing}px 0 ${xlSpacing}px ${xlSpacing}px;
`;

export const SignatureContainer = styled.div`
  flex: 1;
  background-color: ${backgroundZ3};
  width: 80%;
  height: 100%;
  border-radius: 1rem;
  border: 2px solid #13126433;
  overflow: hidden;
`;

export const StyledSignatureCanvas = styled(SignatureCanvas)``;

export const ButtonWrapper = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 120px;
`;

export const ButtonContainer = styled.div`
  transform: rotate(-90deg);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100vh;
  gap: ${xlSpacing}px;
`;

export const ClearButton = styled(Button)``;

export const ConfirmButton = styled(Button)``;
